<template>
  <model-table
    title="Tiers"
    :collection="membershipType.membershipTiers"
    orderable
    order-field="priorityOrder"
    display-order-title="Set Priority Order"
    display-order-description="The first valid tier will be applied to applicable members. Drag higher priority tiers to the top."
    submodel
    :columns="[
      { field: 'name' },
      { field: 'formattedConditions', align: 'left', label: 'Conditions', component: 'chips', limitValues: 3 },
      { name: 'actions', align: 'right' }
    ]"
    add-label="Tier"
  >
    <membership-tier-form
      ref="membershipTierForm"
      :submodel="true"
      :membership-type="membershipType"
      @add-model="membershipTier => $emit('add-model', membershipTier)"
    />
  </model-table>
</template>

<script>

import MembershipType from 'src/models/membership-type/MembershipType'
import ModelTable from 'src/modules/admin/components/ModelTable'
import MembershipTierForm from 'src/modules/admin/membership-type/MembershipTierForm'

export default {
  name: 'MembershipTierTable',
  components: {
    ModelTable,
    MembershipTierForm
  },
  props: {
    membershipType: {
      type: MembershipType,
      required: true
    }
  },
  emits: ['add-model']
}
</script>
